/* eslint-disable no-underscore-dangle */
import { safeJSONParse, safeJSONStringify } from 'core/utils';
import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { useSafeDispatch } from './useSafeDispatch';

interface Options {
  debounce: boolean;
  delay: number;
}

function read<State>(key: string, defaultValue: State): State {
  const value = localStorage.getItem(key);
  if (value) {
    return safeJSONParse(value, defaultValue);
  }
  return defaultValue;
}

function set<State>(key: string, value: State): void {
  const stringifiedValue = safeJSONStringify(value, '__NO_DEFAULT__');
  if (stringifiedValue !== '__NO_DEFAULT__') {
    localStorage.setItem(key, stringifiedValue);
  }
}

export function useLocalStorageState<State>(
  key: string,
  defaultValue: State
): [State, Dispatch<SetStateAction<State>>] {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const [state, _setState] = useState(read<State>(key, defaultValue));
  const setSafeDispatch = useSafeDispatch<State>(_setState);
  useEffect(() => {
    set(key, state);
  }, [setSafeDispatch, key, state]);
  return [state, setSafeDispatch];
}
